export default {
  getGeneralInfo: ({ brokerDealerInvestor }) => brokerDealerInvestor,
};
